export const BASE = {company: {
  logo: "https://storage.googleapis.com/companies-assets/santos-fc/santos-fc_20231010152459.png",
  background_image: "https://storage.googleapis.com/companies-assets/santos-fc/onboarding-santos-bg.jpg",
  primaryColor: "#ba8a4d",
  secondaryColor: "#000000",
  tertiaryColor: "#ba8a4d",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'santos-opsh9',
  name: 'Santos',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'aac3a061-7d13-45ee-a8b3-47338bf976a9',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'https://www.santosfc.com.br/compra-ingressos',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'social@santosfc.com.br'
    },{
      type: 'Whatsapp',
      value: '(13) 3257-4001'
    }
  ],
  optin_form: false,
  iframe_liveness: true,
  dpo_email: 'privacidade@santos.com.br',
  signup_block: false as false | undefined,
  /* Bloqueia o cadastro do tenant (lido em Welcome.tsx como `signup_block !== false`).
    `false` desabilita o signup; `undefined` mantém habilitado (padrão).
    O cast `false | undefined` é obrigatório: sem ele o TS infere apenas `undefined` e
    tenants sem esse campo (ex: Palmeiras) perdem a segurança de tipo via Object.assign.
  */
  invalidPostbackIsActive: undefined as boolean | undefined,
}
}

export async function loadBaseFromApi() {
  // const res = await fetch('/');
  // const data = await res.json();
  // To set an api <3 

  const currentUrl = window.location.href

  const hml_vars = new URLSearchParams(window.location.search);
  let _homol_company_validation = hml_vars.get('cmp') || ''

  if(_homol_company_validation === ''){
    _homol_company_validation = sessionStorage.getItem('selected_cmp') || ''
  }

  if (new RegExp(`flamengo`).test(currentUrl) || 
  new RegExp(`flamengo`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/flamengo/client_logo.png",
  background_image: "https://storage.googleapis.com/companies-assets/flamengo/flamengo_onboarding_bg.jpg",
  primaryColor: "#d70008",
  secondaryColor: "#1f1d1d",
  tertiaryColor: "#541b10",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'flamengo-zjbgi',
  name: 'Flamengo',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'aac3a061-7d13-45ee-a8b3-47338bf976a9',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'https://ingressos.flamengo.com.br/',
    visitor: 'https://www.futebolcard.com/'
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'biometria@flamengo.com.br'
    },{
      type: 'Telefone',
      value: '(21) 3512 1212'
    }
  ],
  dpo_email: 'privacidade@flamengo.com.br',
  optin_form: true,
  iframe_liveness: true,
  signup_block: false,
  iframe_url: 'https://staging.flamengo.bepass.com.br/',
  iframe_key: 'r001-e031910b-5ec8-4aa8-b2bb-03dfe93286c9'
}
});
  }else if (new RegExp(`bilheteriadigital`).test(currentUrl) || 
  new RegExp(`bilheteriadigital`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/bilheteria-digital/logo-bilheteria-digital.jpg",
  background_image: "https://storage.googleapis.com/companies-assets/bilheteria-digital/bg.png",
  primaryColor: "#ea030f",
  secondaryColor: "#8f0028",
  tertiaryColor: "#541b10",
  copyrightLogo: "default",
  backgroundColor: ["#8f0028", "#8f0028"],
  tenant: 'bilheteria-digital-spdgv',
  name: 'Bilheteria Digital',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: '62f63762-97c9-42f9-b33e-87b7fcc91fab',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'https://www.bilheteriadigital.com',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    }
  ],
  dpo_email: 'privacidade@bepass.com.br',
  optin_form: false
}
});
  }else if (new RegExp(`eventim`).test(currentUrl) || 
  new RegExp(`eventim`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/eventim/logo_eventim.png",
  background_image: "https://storage.googleapis.com/companies-assets/bilheteria-digital/bg.png",
  primaryColor: "#202867",
  secondaryColor: "#000000",
  tertiaryColor: "#f9fafb",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'eventim-cri67',
  name: 'Eventim',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'e3446515-322a-49a0-b8fc-490aaf045f96',
  dis: 0.87,
  isEvent: true,
  buttonPay: false,
  call_to_action: {
    ticket: 'https://www.eventim.com.br/',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    },{
      type: 'Whatsapp',
      value: '(11) 97481 7370'
    }
  ],
  dpo_email: 'suporte@bepass.com.br',
  optin_form: false,
  iframe_liveness: true,
  iframe_url: 'https://eventim.bepass.com.br',
  iframe_key: 'r001-0fbea447-4b14-47b1-ba0f-acd4f0329310'
}
});
  }else if (new RegExp(`botafogo`).test(currentUrl) || 
  new RegExp(`botafogo`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/botafogo/client_logo.58472699ee7531a3cacb.png",
  background_image: "https://storage.googleapis.com/companies-assets/santos-fc/onboarding-santos-bg.jpg",
  primaryColor: "#000000",
  secondaryColor: "#ba8a4d",
  tertiaryColor: "#541b10",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'botafogo-lk5fp',
  name: 'Botafogo',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: '6e7fc4d2-2b5e-48b9-acad-da23b5011b26',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'https://www.botafogo.com.br/',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'contato@ingresse.com'
    }
  ],
  dpo_email: 'privacidade@botafogo.com.br',
  optin_form: false,
  iframe_liveness: true,
}});
  }else if (new RegExp(`fluminense`).test(currentUrl) || 
  new RegExp(`fluminense`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/fluminense/fluminense_2023619115226.png",
  background_image: "https://storage.googleapis.com/companies-assets/fluminense/fluminense_bg_onboarding.jpg",
  primaryColor: "#7D0A20",
  secondaryColor: "#006338",
  tertiaryColor: "#541b10",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'fluminense-xt4im',
  name: 'Fluminense',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: '2c25d521-193c-4237-b80c-d1675335366f',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'http://fluminense.futebolcard.com',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'falameusocio@fluminense.com.br'
    },{
      type: 'Telefone',
      value: '+55 21 3512-2500'
    }
  ],
  dpo_email: 'privacidade@fluminense.com.br',
  optin_form: false,
  iframe_liveness: true,
  iframe_url: 'https://staging.fluminense.bepass.com.br',
  iframe_key: 'r001-040f2227-48fd-46ce-b763-52a11f411f77'
}
});
  }else if (new RegExp(`gremio`).test(currentUrl) || 
  new RegExp(`gremio`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/arena-gremio/gremio-onboarding-logo_plus.png",
  background_image: "https://storage.googleapis.com/companies-assets/arena-gremio/onboarding-gremio-bg.jpg",
  primaryColor: "#0581C0",
  secondaryColor: "#ba8a4d",
  tertiaryColor: "#541b10",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'gremio-ewf1d',
  name: 'Grêmio',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'e5905d4c-b0fd-43e7-8586-644772f812ae',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'https://gremio.net/',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'centralderelacionamento@gremio.net'
    },{
      type: 'Telefone',
      value: '(51) 3092-9605'
    }
  ],
  dpo_email: 'privacidade@gremio.com.br',
  optin_form: false,
  iframe_liveness: true,
}
});
  }else if (new RegExp(`palmeiras`).test(currentUrl) || 
  new RegExp(`palmeiras`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/palmeiras/logo_palmeiras.svg",
  background_image: "https://storage.googleapis.com/companies-assets/palmeiras/onboarding-palmeiras-bg.jpg",
  primaryColor: "#006437",
  secondaryColor: "#198754",
  tertiaryColor: "#91cb98",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'palmeiras-pmxzp',
  name: 'Palmeiras',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'a4167a0e-9014-4e0a-bfb3-967401ca34ae',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'https://ingressospalmeiras.com.br/',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    }
  ],
  dpo_email: 'privacidade@palmeiras.com.br',
  optin_form: false
}
});
  }else if (new RegExp(`santos`).test(currentUrl) || 
  new RegExp(`santos`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/santos-fc/santos-fc_20231010152459.png",
  background_image: "https://storage.googleapis.com/companies-assets/santos-fc/onboarding-santos-bg.jpg",
  primaryColor: "#ba8a4d",
  secondaryColor: "#000000",
  tertiaryColor: "#ba8a4d",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'santos-opsh9',
  name: 'Santos',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'aac3a061-7d13-45ee-a8b3-47338bf976a9',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'https://www.santosfc.com.br/compra-ingressos',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'social@santosfc.com.br'
    },{
      type: 'Whatsapp',
      value: '(13) 3257-4001'
    }
  ],
  dpo_email: 'privacidade@santos.com.br',
  optin_form: false,
  iframe_liveness: true,
  signup_block: false,
}
});
  }else if (new RegExp(`sao-paulo`).test(currentUrl) || 
  new RegExp(`sao-paulo`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/sao-paulo-fc/sao-paulo-fc_20231111182624.png",
  background_image: "https://storage.googleapis.com/companies-assets/sao-paulo-fc/onboarding_sao_paulo.jpg",
  primaryColor: "#d70008",
  secondaryColor: "#000000",
  tertiaryColor: "#541b10",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'saopaulo-oj8c8',
  name: 'São Paulo',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: '0309214a-b846-48d7-97da-d506ac044059',
  dis: 0.87,
  isEvent: false,
  buttonPay: true,
  call_to_action: {
    ticket: 'https://www.spfcticket.net/',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    }
  ],
  dpo_email: 'privacidade@saopaulo.com.br',
  optin_form: false
}
});
  }else if (new RegExp(`cas2026`).test(currentUrl) || 
  new RegExp(`cas2026`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/cas2026/CAS25-LOGO.jpg",
  background_image: "https://storage.googleapis.com/companies-assets/cas2026/background-catarina.png",
  primaryColor: "#B3CA79",
  secondaryColor: "#000000",
  tertiaryColor: "#91cb98",
  copyrightLogo: "none",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'cas2026-ibmvh',
  name: 'Catarina Aviation Show',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_color_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'dffc80b8-dac5-4bb4-9604-4bf30d6c81dc',
  dis: 0.87,
  isEvent: true,
  buttonPay: false,
  call_to_action: {
    ticket: null,
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail(Visitante)',
      value: 'catarina-mkt@nm-brasil.com.br'
    },{
      type: 'Whatsapp(Visitante)',
      value: '(11) 98839-9731 - Gabriela Magalhães'
    },
    {
      type: 'E-mail(Expositor e Staff)',
      value: 'ana.julia@nmbpartner.com.br'
    },{
      type: 'Whatsapp(Expositor e Staff)',
      value: '(11) 97539-9670 - Ana Julia'
    },
  ],
  dpo_email: 'catarina-mkt@nm-brasil.com.br',
  optin_form: false,
  invalidPostbackIsActive: true
}
});
  }else if (new RegExp(`clube-pinheiros`).test(currentUrl) || 
  new RegExp(`clube-pinheiros`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.cloud.google.com/companies-assets/clube-pinheiros/logo.png",
  background_image: "https://storage.googleapis.com/companies-assets/bilheteria-digital/bg.png",
  primaryColor: "#0c67ab",
  secondaryColor: "#0a5d9b",
  tertiaryColor: "#000000",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'clube-pinheiros-3bp76',
  name: 'Clube Pinheiros',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: '3a3249be-0fbe-4e9d-96dc-9d07ec7e37db',
  dis: 0.87,
  isEvent: false,
  buttonPay: false,
  call_to_action: {
    ticket: null,
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    }
  ],
}
});
  }else if (new RegExp(`barueri`).test(currentUrl) || 
  new RegExp(`barueri`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.cloud.google.com/companies-assets/barueri/logo-barueri.png",
  background_image: "https://storage.googleapis.com/companies-assets/bilheteria-digital/bg.png",
  primaryColor: "#004B8D",
  secondaryColor: "#0077C8",
  tertiaryColor: "#91cb98",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'barueri-khjth',
  name: 'Barueri',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: '53eb83ac-1213-48f8-8f2e-8c7f2f83405c',
  dis: 0.87,
  isEvent: false,
  buttonPay: false,
  call_to_action: {
    ticket: null,
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    }
  ],
  dpo_email: 'privacidade@bepass.com.br',
  optin_form: false
}
});
  }else if (new RegExp(`demo.bepass`).test(currentUrl) || 
  new RegExp(`demo.bepass`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/bepass/bepass-small-logo.png",
  background_image: "https://storage.googleapis.com/companies-assets/bepass/bepass-bg-default.png",
  primaryColor: "#8ac91a",
  secondaryColor: "#476c07",
  tertiaryColor: "#476c07",
  copyrightLogo: "default",
  backgroundColor: ["#8ac91a", "#476c07"],
  tenant: 'bepass-8qt9o',
  name: 'Bepass',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'a6a27339-88a2-4798-b21d-4656c8570892',
  dis: 0.87,
  isEvent: false,
  buttonPay: false,
  call_to_action: {
    ticket: 'https://www.yourticketsite.com/',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    }
  ],
  dpo_email: 'suporte@bepass.com.br',
  optin_form: false,
  iframe_liveness: true,
  iframe_url: 'https://demo.bepass.com.br',
  iframe_key: 'r001-7424d7a9-954a-4116-9674-9b025a49fb27'
}
});
  }else if (new RegExp(`oral-b`).test(currentUrl) || 
  new RegExp(`oral-b`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/oral-b/oral-b-log.svg",
  background_image: "https://storage.googleapis.com/companies-assets/bilheteria-digital/bg.png",
  primaryColor: "#1E4D8F",
  secondaryColor: "#2A6EBB",
  tertiaryColor: "#FFFFFF",
  copyrightLogo: "default",
  backgroundColor: ["#1E4D8F", "#2A6EBB"],
  slugName: 'oral-b',
  tenant: 'oral-b-oqdzy',
  name: 'Oral B',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'b26bdc87-36c1-462a-9a83-24731bb19768',
  dis: 0.87,
  isEvent: true,
  buttonPay: false,
  call_to_action: {
    ticket: '',
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: ''
    }
  ],
  optin_form: true,
  iframe_liveness: true,
  dpo_email: '',
  iframe_url: 'https://onboarding-oral-b.bepass.com.br',
  iframe_key: 'r001-63b904b2-c620-4f8c-b5c8-e9486991a655'
}
});
  }else   if (new RegExp(`ingresse`).test(currentUrl) || 
  new RegExp(`ingresse`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/ingresse/logoIngresse.png",
  background_image: "https://storage.googleapis.com/companies-assets/ingresse/bg-onboarding-ingresse.png",
  primaryColor: "#00b0d0",
  secondaryColor: "#8ac91a",
  tertiaryColor: "#1f2123ff",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'ingresse-yyyho',
  name: 'Ingresse',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: '2cfe1777-1bad-4252-9a0d-b9f5d8bbaac3',
  dis: 0.87,
  call_to_action: {
    ticket: null,
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'contato@ingresse.com.br'
    }
  ],
  dpo_email: 'contato@ingresse.com.br',
  optin_form: false,
  iframe_liveness: true,
  iframe_url: 'https://ingresse.bepass.com.br',
  iframe_key: 'r001-c96183a4-1030-416a-a125-9cd766b45720'
}
});
  }else   if (new RegExp(`uber`).test(currentUrl) || 
  new RegExp(`uber`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/uber/logo.png",
  background_image: "https://storage.googleapis.com/companies-assets/bilheteria-digital/bg.png",
  primaryColor: "#000000",
  secondaryColor: "#FFFFFF",
  tertiaryColor: "#276EF1",
  copyrightLogo: "default",
  backgroundColor: ["#000000", "#000000"],
  tenant: 'uber-1mpqh',
  name: 'Uber',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: '53c83472-be76-47e0-b1ba-9023bee5175b',
  dis: 0.87,
  call_to_action: {
    ticket: null,
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    }
  ],
  dpo_email: 'suporte@bepass.com.br',
  optin_form: false,
  iframe_liveness: true,
  iframe_url: 'https://uber.bepass.com.br',
  iframe_key: 'r001-56e372fb-6425-4388-8487-5ff3342665a7'
}
});
  }else   if (new RegExp(`bepass-fc`).test(currentUrl) || 
  new RegExp(`bepass-fc`).test(_homol_company_validation)
  ) {
    Object.assign(BASE, {company: {
  logo: "https://storage.googleapis.com/companies-assets/bepass/bepass-fc.png",
  background_image: "https://storage.googleapis.com/companies-assets/bepass/bepass-bg-default.png",
  primaryColor: "#8ac91a",
  secondaryColor: "#476c07",
  tertiaryColor: "#476c07",
  copyrightLogo: "default",
  backgroundColor: ["#8ac91a", "#476c07"],
  tenant: 'bepass-fc-02vzo',
  name: 'Bepass FC',
  bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
  bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
  id: 'a6a27339-88a2-4798-b21d-4656c8570892',
  dis: 0.87,
  isEvent: false,
  buttonPay: false,
  call_to_action: {
    ticket: null,
    visitor: null
  },
  contact_data: [
    {
      type: 'E-mail',
      value: 'suporte@bepass.com.br'
    }
  ],
  dpo_email: 'suporte@bepass.com.br',
  optin_form: false,
  iframe_liveness: true,
  iframe_url: 'https://onboarding-bepass-fc.bepass.com.br/',
  iframe_key: 'r001-9392c194-c2d1-4a7b-bdfe-0cbf578ab1c5'
}
});
}else   if (new RegExp(`velez`).test(currentUrl) || 
new RegExp(`velez`).test(_homol_company_validation)
) {
  Object.assign(BASE, {company: {
logo: "https://storage.googleapis.com/companies-assets/velez/velez-logo.png",
background_image: "https://storage.googleapis.com/companies-assets/velez/vs-background.png",
primaryColor: "#000000",
secondaryColor: "#FFFFFF",
tertiaryColor: "#276EF1",
copyrightLogo: "default",
backgroundColor: ["#000000", "#000000"],
tenant: 'velez-rsda0',
name: 'Velez',
bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
bepassMobileLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_gray.png",
id: '30e49d6d-7ac1-477d-9a88-12e2f888422d',
dis: 0.87,
call_to_action: {
  ticket: null,
  visitor: null
},
contact_data: [
  {
    type: 'E-mail',
    value: 'suporte@bepass.com.br'
  }
],
dpo_email: 'suporte@bepass.com.br',
optin_form: false,
iframe_liveness: true,
iframe_url: 'https://velez.bepass.com.br',
iframe_key: 'r001-b23b571b-d2e3-4abb-b271-8b0055acbcfe'
}
});
  }
}


export const isEvent = () => BASE.company.isEvent === true;
export const shouldShowBepassLogo = () => BASE.company.copyrightLogo !== 'none';
export const shouldUseOptIn = () =>
  BASE.company.tenant.startsWith('flamengo-') && BASE.company.optin_form === true;

export const getPrivacyNoticeUrl = () =>
  BASE.company.tenant.startsWith('cas2026-')
    ? '/catarina-aviation-privacy-notice.pdf'
    : 'https://storage.googleapis.com/companies-assets/bepass/bepass_terms.pdf';

export const getClientKey = (key: string) =>
  BASE.company.isEvent ? `event.${key}` : key;
